export const getSDKConfig = () => {
  const defaultTvConfig = {
    investor_events: {
      isGADefaultAllow: true,
    },
    default_behavior: true,
    blacklist: {
      event_types: ['others'],
      event_categories: ['debug'],
      event_name: ['test_event'],
    },
    priority: {
      max_retries: 5,
      retry_backoff: 2000,
      discard_on_failure: true,
      offline_cache_enabled: true,
      offline_cache_flush_interval: 604800,
      offline_cache_max_size: 200,
    },
    batch: {
      max_retries: 3,
      retry_backoff: 5000,
      discard_on_failure: false,
      compression_enabled: true,
      offline_cache_enabled: true,
      offline_cache_flush_interval: 604800,
      queue_size: 5,
      batch_interval: 60000,
      max_events_per_beacon: 5,
      offline_cache_max_size: 200,
    },
    general: {
      app_session_timeout: 1800000,
      api_timeout: 15000,
      debug_mode: false,
      compression: {
        enabled: true,
      },
      rate_limit: {
        enabled: true,
        max_beacons_per_minute: 120,
        burst_limit: 50,
      },
      beacon_flush_on_critical: true,
      endpoints: {
        priority: 'https://evt.sonyliv.com/v2/smarttv/priority/records',
        batched: 'https://evt.sonyliv.com/v2/smarttv/batched/records',
      },
    },
    priority_events: [
      'watch_cta_click',
      'view_item_list',
      'asset_click',
      'video_stop',
      'video_start_failure',
      'video_start',
      'video_play_start',
      'log_in_success',
      'log_in_detail_submit',
      'video_ad_start',
      'video_ad_request',
      'video_ad_response_received',
      'video_ad_complete',
      'video_ad_error',
      'screenview_manual',
      'pageview_manual',
      'subscription_success',
      'subscription_proceed_click',
      'subscription_payment_method_select',
      'sub_tv_activation_click',
      'sub_proceed_to_pay_click',
      'qr_scan_login_success',
      'qr_scan_login_detail_submit',
      'hamburger_menu_subscribe_click',
      'get_premium_click',
      'free_preview_subscribe_click',
      'app_speed_event',
      'video_session_start',
      'app_launch',
      'session_start',
      'launch_splash',
      'multiprofile_select_profile',
      'search_initiate_click',
      'search_trigger',
      'subscription_exit',
      'video_ad_exit',
      'login_entry',
      'multiprofile_select_profile_get_in',
      'log_in_initiation',
      'log_in_otp_submit',
      'log_in_detail_entry',
      'otp_generate_success',
      'log_in_error',
      'log_out_success',
      'stream_concurrency_popup',
      'email_sign_in',
      'subscription_error',
      'sign_in_success',
      'upgrade_subscription_success',
      'multiprofile_add_profile_confirm',
      'app_launch_reason',
      'previous_login_account_click',
      'preview_running_subscribe_click',
      'subscribe_now_ads_page_click',
      'session_start_manual',
      'qr_scan_notification_click',
      'qr_scan_button_click',
      'sub_smarthook_click',
      'sso_log_in_error',
      'sso_log_in_success',
      'log_in_social_detail_submit',
      'generate_qr_code_click',
    ],
  };

  const defaultWebConfig = {
    default_behavior: true,
    investor_events: { isGADefaultAllow: true },
    blacklist: {
      event_types: ['others'],
      event_categories: ['debug'],
      event_name: ['test_event'],
    },
    priority: {
      max_retries: 5,
      retry_backoff: 2000,
      discard_on_failure: true,
      offline_cache_enabled: true,
      offline_cache_flush_interval: 604800,
      offline_cache_max_size: 1000,
    },
    batch: {
      max_retries: 3,
      retry_backoff: 5000,
      discard_on_failure: false,
      compression_enabled: true,
      offline_cache_enabled: true,
      offline_cache_flush_interval: 604800,
      queue_size: 50,
      batch_interval: 60000,
      max_events_per_beacon: 5,
      offline_cache_max_size: 1000,
    },
    general: {
      app_session_timeout: 1800000,
      debug_mode: false,
      compression: {
        enabled: true,
      },
      rate_limit: {
        enabled: true,
        max_beacons_per_minute: 120,
        burst_limit: 50,
      },
      beacon_flush_on_critical: true,
      endpoints: {
        priority: 'https://evt.sonyliv.com/v2/web/priority/records',
        batched: 'https://evt.sonyliv.com/v2/web/batched/records',
      },
      api_timeout: 30000,
    },
    priority_events: [
      'watch_cta_click',
      'view_item_list',
      'asset_click',
      'video_stop',
      'video_start_failure',
      'video_start',
      'video_play_start',
      'log_in_success',
      'log_in_detail_submit',
      'video_ad_start',
      'video_ad_request',
      'video_ad_response_received',
      'video_ad_complete',
      'video_ad_error',
      'screenview_manual',
      'pageview_manual',
      'subscription_success',
      'subscription_proceed_click',
      'subscription_payment_method_select',
      'sub_tv_activation_click',
      'sub_proceed_to_pay_click',
      'qr_scan_login_success',
      'qr_scan_login_detail_submit',
      'hamburger_menu_subscribe_click',
      'get_premium_click',
      'free_preview_subscribe_click',
      'app_speed_event',
      'video_session_start',
      'app_launch',
      'session_start',
      'launch_splash',
      'multiprofile_select_profile',
      'search_initiate_click',
      'search_trigger',
      'subscription_exit',
      'video_ad_exit',
      'login_entry',
      'multiprofile_select_profile_get_in',
      'log_in_initiation',
      'log_in_otp_submit',
      'log_in_detail_entry',
      'otp_generate_success',
      'log_in_error',
      'log_out_success',
      'stream_concurrency_popup',
      'email_sign_in',
      'subscription_error',
      'sign_in_success',
      'upgrade_subscription_success',
      'multiprofile_add_profile_confirm',
      'app_launch_reason',
      'previous_login_account_click',
      'preview_running_subscribe_click',
      'subscribe_now_ads_page_click',
      'session_start_manual',
      'qr_scan_notification_click',
      'qr_scan_button_click',
      'sub_smarthook_click',
      'sso_log_in_error',
      'sso_log_in_success',
      'log_in_social_detail_submit',
      'generate_qr_code_click',
    ],
  };

  const localPlatform = localStorage.getItem('GV_NETWORK_PLATFORM_TYPE');

  let defaultConfig = defaultTvConfig;
  if (localPlatform === 'WEB') {
    defaultConfig = defaultWebConfig;
  }

  let localSDK = null;
  try {
    const gvlocalSDK = localStorage.getItem('GV_SDK_CONFIG');
    if (gvlocalSDK) {
      let storedSdk = JSON.parse(gvlocalSDK);
      if (
        typeof storedSdk === 'object' &&
        storedSdk !== null &&
        Object.keys(storedSdk).length > 0
      ) {
        localSDK = storedSdk;
      }
    }
  } catch (e) {
    console.info('wrong localSDK', e);
  }

  const config =
    window.spnGlobalConfig?.spnGodavariGaAnalyticsConfig ||
    (typeof localSDK === 'object' && !!localSDK && localSDK) ||
    defaultConfig;
  return config;
};

export function setSDKConfig(config) {
  if (window.spnGlobalConfig && config) {
    //dispatch all previous events if currently present in queue with old config
    window.spnGlobalConfig.spnGodavariGaAnalyticsConfig = config;
    localStorage.setItem('GV_SDK_CONFIG', JSON.stringify(config));
  }
}
